/**
 * Checks whether a Cloud directory is a special "sync"
 * directory which is manages by rsync or similar tools.
 */
export const isSyncDirectory = (directory: string) => {
  return directory.startsWith("/sync");
};
